





































































































































































































































































































































































































































































































































































































































































































import "./index.scss";
import iSwitch from "../../components/i-switch.vue";
import iSlider from "../../components/i-slider.vue";
import iBarchart from "../../components/i-barchart.vue";
import iScrollView from "../../components/i-scrollview.vue";
import iScalerViewer from "../../components/i-scaler-viewer.vue";
import iDropdown from "../../components/i-dropdown.vue";
import iTab from "../../components/i-tab.vue";
import iMessage from "../../components/i-message.vue";
import { Component, Vue } from "vue-property-decorator";
import { DropdownItem, HomeData, MessageConfig, TabItem } from "@/types";
@Component({
  components: {
    iSwitch,
    iSlider,
    iBarchart,
    iScrollView,
    iScalerViewer,
    iDropdown,
    iTab,
    iMessage
  }
})
export default class Space extends Vue {
  /**
   * nav
   */
  private navDotTransform: string = "";
  private navTitleTransform: string = "";
  private navIndex: number | null = null;
  private prevNavIndex: number = 0;

  private dW = 1200;
  private dH = 800;

  //开关公知
  private isOpen = {
    init: false,
    reachme: false,
    interest: false,
    music: false
  };

  //动画效果
  private meAnime: any = {
    header: null,
    profile: null,
    interest: null,
    music: null,
    reachme: null
  };

  private isLoved = false;

  private pictureTab = "picture";
  private pictureTabConfig: TabItem[] = [
    {
      name: "picture",
      title: "",
      icon: "me-picture"
    },
    {
      name: "paint",
      title: "",
      icon: "me-paint"
    }
  ];

  private isMessageShow = false;
  private messageConfig: MessageConfig = {
    title: ""
  };

  private lang = "en-US";
  private langConfig: DropdownItem[] = [
    {
      name: "zh-CN",
      title: "简",
      icon: "me-china"
    },
    {
      name: "zh-HK",
      title: "繁",
      icon: "me-hongkong"
    },
    {
      name: "en-US",
      title: "En",
      icon: "me-usa"
    },
    {
      name: "ja-JP",
      title: "日",
      icon: "me-japan"
    }
  ];

  private theme = true;

  private interface: { [key: string]: any } = {};

  // private mainAnime: any = {
  //   home: {
  //     top: {

  //     },
  //     mid: null,
  //     btm: null
  //   }
  // }

  private musicActiveTransform: string = "";

  /**
   * music
   */
  private player: HTMLAudioElement | null = null;
  private play: HTMLElement | null = null;
  private playlist: HTMLElement | null = null;
  private firstnav: HTMLElement | null = null;
  private secondnav: HTMLElement | null = null;
  private thirdnav: HTMLElement | null = null;
  private main: HTMLElement | null = null;

  private navTimer: number = 0;

  private reachme: HTMLElement | null = null;

  private music = {
    isPlay: false,
    waitingPlay: false,
    volume: 0,
    volumeTimer: 0,
    currentIndex: 0, //当前播放第几个
    currentPer: 0, //当前播放比例
    buffered: 0, //当前缓冲比例
    resetCover: false,
    reloadCover: false,
    playlist: []
  };

  //拖拽时间
  private dragEvent = {
    isStart: false,
    startX: 0,
    startY: 0,
    newX: 0,
    newY: 0
  };

  private eleBounds = {
    pW: 0,
    pH: 0,
    barH: 0,
    bar_0: {
      y: 0,
      bottom: 0
    },
    bar_1: {
      y: 0,
      bottom: 0
    },
    bar_2: {
      y: 0,
      bottom: 0
    }
  };

  private homeScoreColor: string = "";
  private today: { week: string; date: string } = {
    week: "",
    date: ""
  };

  //兴趣列表
  private interestList = [];

  private homeData: HomeData = {};

  private momentData = {};

  private workData = {};

  mounted() {
    this.hello();

    this.reachme = this.$refs.reachme as HTMLElement;
    this.firstnav = this.$refs.firstnav as HTMLElement;
    this.secondnav = this.$refs.secondnav as HTMLElement;
    this.thirdnav = this.$refs.thirdnav as HTMLElement;
    this.main = this.$refs.main as HTMLElement;

    this.calcBounds();
    const that = this;
    window.onresize = function() {
      that.calcBounds();
    };
    this.$axios
      .get(`/api/app/getData`)
      .then((response: any) => {
        if (response.status === 200) {
          if (this.$utils.isObject(response.data)) {
            const d = response.data;
            if (d.success) {
              this.initInterface(d.data);
            } else {
              alert("unable to read data, please try later");
            }
          } else {
            alert("unable to read data, please try later");
          }
        }
      })
      .catch((error: any) => {
        alert("unable to read data, please try later");
        console.log(error);
      });
    this.$lang.init().then((lang: string) => {
      this.initLangRelatives(lang);
    });

    this.initTheme();

    this.initLove();

    this.$bus.$on("goto", (href: string) => {
      this.goTo(href);
    });
  }

  private hello() {
    const helloworld =
      "                ☰      ☰                    \n" +
      "                  ☰   ☰                     \n" +
      "                    ☰☰                      \n" +
      "    ☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶     \n" +
      "  ☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷   \n" +
      "☷☷☷☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☳☷☷☷\n" +
      "☳☳☳                                    ☳☳☳\n" +
      "☶☶☶      ▨▨▨▨▨      ▨       ▨▨▨▨       ☶☶☶\n" +
      "☷☷☷        ▨       ▨▨▨     ▨    ▨      ☷☷☷\n" +
      "☳☳☳        ▨      ▨   ▨     ▨▨▨▨       ☳☳☳\n" +
      "☲☲☲                                    ☲☲☲\n" +
      "☶☶☶      ▨  ▨  ▨  ▨    ▨▨▨   ▨▨▨       ☶☶☶\n" +
      "☷☷☷       ▨▨▨▨▨  ▨▨▨  ▨   ▨ ▨  ▨▨      ☷☷☷\n" +
      "☳☳☳        ▨ ▨  ▨   ▨ ▨   ▨ ▨▨▨▨▨      ☳☳☳\n" +
      "☳☳☳                                    ☳☳☳\n" +
      "☲☲☲  > Hi there! |•'-'•) ✧             ☲☲☲\n" +
      "☲☲☲  > R U interested in my works?     ☲☲☲\n" +
      "☲☲☲  > will be glad if you could -     ☲☲☲\n" +
      "☲☲☲  > say hi to me at taow@yahoo.com  ☲☲☲\n" +
      "☶☶☶                                    ☶☶☶\n" +
      "☷☷☷☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☶☷☷☷\n" +
      "  ☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷☷   \n" +
      "    ☳☳☳☳☳☳☳☷☷☷☷☷☷☷☷☷☷☳☳☳☳☳☳☳☳    \n";

    console.log(helloworld);
  }

  private initInterface(data: any) {
    //设置音乐列表
    this.music.playlist = data.playlist;
    //设置兴趣列表
    this.interestList = data.interestList;
    //设置界面数据
    this.interface = data.interface;
    //设置主页分数
    this.setHomeScoreColor();

    this.homeData = data.homeData || {};
    this.momentData = data.momentData || {};
    this.workData = data.workData || {};

    this.navIndex = 0;

    setTimeout(() => {
      this.isOpen.init = true;
    }, 500);
    this.$nextTick(() => {
      //实例化player
      this.player = this.$refs.audio as HTMLAudioElement;
      this.play = this.$refs.play as HTMLElement;
      this.playlist = this.$refs.playlist as HTMLElement;
    });
  }

  private initLangRelatives(lang: string) {
    this.lang = lang;
    this.setToday();
  }

  private setHomeScoreColor() {
    if (this.interface["score_total"]) {
      const score = this.$utils.toNumber(this.interface["score_total"]);
      if (score < 50) {
        this.homeScoreColor = "var(--colorful-pinkred)";
      } else if (score >= 50 && score < 80) {
        this.homeScoreColor = "var(--colorful-yellow)";
      } else {
        this.homeScoreColor = "var(--theme-main-color)";
      }
    }
  }

  private setToday() {
    const d = new Date(),
      day = d.getDay(),
      date = d.getDate(),
      month = d.getMonth(),
      year = d.getFullYear();
    this.today = {
      week: this.$lang.t(`system.week.${day}`),
      date: date + " " + this.$lang.t(`system.month.${month}`) + " " + year
    };
  }

  private getTextNumber(num: number): string {
    let f = 0,
      e = 0,
      u = "";
    if (num >= 1000000) {
      const t = num / 1000000;
      f = parseInt(t.toString());
      e = this.$utils.toFixedNumber(t - f, 1);
      u = "M";
      if (e === 0) return f + u;
      return f + "." + e + u;
    } else if (num >= 1000) {
      const t = num / 1000;
      f = parseInt(t.toString());
      e = this.$utils.toFixedNumber(t - f, 1);
      u = "K";
      if (e === 0) return f + u;
      return f + "." + e + u;
    } else {
      return num.toString();
    }
  }

  private getVW(val: number, pageW?: number) {
    return (val / (pageW || this.dW)) * 100;
  }
  private getVH(val: number, pageH?: number) {
    return (val / (pageH || this.dH)) * 100;
  }

  private calcBounds(isFinal: boolean = false) {
    if (
      this.firstnav !== null &&
      this.secondnav !== null &&
      this.thirdnav !== null
    ) {
      clearTimeout(this.navTimer);
      this.eleBounds.pW = document.body.offsetWidth;
      this.eleBounds.pH = document.body.offsetHeight;
      const firstBarBounds = this.firstnav.getBoundingClientRect(),
        secondBarBounds = this.secondnav.getBoundingClientRect(),
        thirdBarBounds = this.thirdnav.getBoundingClientRect();
      this.eleBounds.barH = this.getVH(
        firstBarBounds.height,
        this.eleBounds.pH
      );
      this.eleBounds.bar_0.y = this.getVH(firstBarBounds.y, this.eleBounds.pH);
      this.eleBounds.bar_0.bottom = this.getVH(
        firstBarBounds.bottom,
        this.eleBounds.pH
      );
      this.eleBounds.bar_1.y = this.getVH(secondBarBounds.y, this.eleBounds.pH);
      this.eleBounds.bar_1.bottom = this.getVH(
        secondBarBounds.bottom,
        this.eleBounds.pH
      );
      this.eleBounds.bar_2.y = this.getVH(thirdBarBounds.y, this.eleBounds.pH);
      this.eleBounds.bar_2.bottom = this.getVH(
        thirdBarBounds.bottom,
        this.eleBounds.pH
      );
      if (!isFinal) {
        const that = this;
        this.navTimer = setTimeout(() => {
          that.calcBounds(true);
        }, 1000);
      }
    }
  }

  /**
   * 开关动画
   */

  private audioCoverChange() {
    this.music.reloadCover = !this.music.reloadCover;
  }

  private openPlaylist() {
    if (this.isOpen.reachme) this.openReachme(this.reachme);
    if (this.isOpen.music) {
      this.isOpen.music = false;
      this.meAnime.header = {
        transform: `translateY(0px)`
      };
      this.meAnime.profile = {
        transform: `translateY(0px)`
      };
      this.meAnime.interest = {
        transform: `translateY(0px)`
      };
      this.meAnime.music = {
        height: `17.5vh`
      };
    } else {
      this.isOpen.music = true;
      const offset = -76.25;
      this.meAnime.header = {
        transform: `translateY(${offset}vh)`
      };
      this.meAnime.profile = {
        transform: `translateY(${offset}vh)`
      };
      this.meAnime.interest = {
        transform: `translateY(${offset}vh)`,
        height: `28.75vh`
      };
      this.isOpen.interest = false;
      this.meAnime.music = {
        height: `calc(100% - 5vh)`
      };
    }
  }

  private openInterest() {
    if (this.isOpen.reachme) this.openReachme(this.reachme);
    if (this.isOpen.interest) {
      this.isOpen.interest = false;
      this.meAnime.header = {
        transform: `translateY(0)`
      };
      this.meAnime.profile = {
        transform: `translateY(0)`
      };
      this.meAnime.interest = {
        transform: `translateY(0)`,
        height: `28.75vh`
      };
    } else {
      this.isOpen.interest = true;
      const offset = -45;
      this.meAnime.header = {
        transform: `translateY(${offset}vh)`
      };
      this.meAnime.profile = {
        transform: `translateY(${offset}vh)`
      };
      this.meAnime.interest = {
        transform: `translateY(${offset}vh)`,
        height: `calc(100% - 25vh)`
      };
    }
  }

  private onLangChange(lang: string) {
    this.$lang.set(lang).then(() => {
      this.initLangRelatives(lang);
    });
  }

  private openReachme(target: any) {
    const dots = target.children;
    if (this.isOpen.reachme) {
      dots[0].style.cssText = "top: 2.5vh; left: 1vh";
      dots[2].style.cssText = "top: 2.5vh; left: 3.5vh";
      dots[3].style.cssText = "top: 2.5vh; left: 2.25vh";
      dots[4].style.cssText = "top: 2.5vh; left: 2.25vh";
      this.meAnime.reachme = {
        height: "0"
      };
    } else {
      dots[0].style.cssText = "top: 1.5vh; left: 1.25vh";
      dots[2].style.cssText = "top: 3.5vh; left: 3.25vh";
      dots[3].style.cssText = "top: 1.5vh; left: 3.25vh";
      dots[4].style.cssText = "top: 3.5vh; left: 1.25vh";
      this.meAnime.reachme = {
        height: "9vh"
      };
    }
    this.isOpen.reachme = !this.isOpen.reachme;
  }

  /**
   * music
   */

  //startDragAudioBar 开始拖拽音频的进度条
  private startDragAudioBar(ev: any) {
    this.dragEvent.isStart = true;
    this.dragEvent.startX = ev.pageX;
    ev.target.style.transition = "ease 0s";
  }

  //dragingAudioBar 正在拖拽音频的进度条
  private dragingAudioBar(ev: any) {
    if (this.dragEvent.isStart) {
      const currentX = ev.pageX,
        diffX = currentX - this.dragEvent.startX,
        perX = diffX / 1.09;
      let newPos = this.music.currentPer + perX;
      if (newPos < 0) {
        newPos = 0;
      } else if (newPos > 100) {
        newPos = 100;
      }
      this.dragEvent.newX = newPos;
      ev.target.style.left = newPos + "%";
    }
  }

  //endDragAudioBar 结束拖拽音频的进度条
  private endDragAudioBar(ev: any) {
    if (this.dragEvent.isStart) {
      this.dragEvent.isStart = false;
      this.music.currentPer = this.dragEvent.newX;
      this.setAudioCurrentTime(this.music.currentPer);
      ev.target.style.transition = "ease 0.3s";
    }
  }

  private changeAudio(index: number) {
    if (this.play !== null) {
      if (this.music.currentIndex !== index) {
        this.doChangeAudio(index);
      } else {
        if (this.music.isPlay) {
          this.pauseAudio(this.play, true);
        } else {
          this.playAudio(this.play, true);
        }
      }
    }
  }

  private doChangeAudio(index: number) {
    if (this.playlist !== null) {
      clearInterval(this.music.volumeTimer);
      this.musicActiveTransform = `translateY(${index * 6.25}vh)`;
      this.playlist.children[this.music.currentIndex].classList.remove(
        "active",
        "playing"
      );
      this.playlist.children[index].classList.add("active");
      this.music.currentIndex = index;
      this.music.resetCover = !this.music.resetCover;
      this.loadAudioAndPlay();
    }
  }

  private loadAudioAndPlay() {
    if (this.player !== null) {
      this.player.load();
      this.music.waitingPlay = true;
    }
  }

  //setAudioCurrentTime 设置当前音频时间
  private setAudioCurrentTime(per: number) {
    if (this.player !== null && this.play !== null) {
      if (!this.music.isPlay) {
        this.playAudio(this.play);
      }
      this.player.currentTime = (per / 100) * this.player.duration;
    }
  }

  //handleAudioEnd 接受音频结束事件
  private handleAudioEnd() {
    if (this.player !== null && this.play !== null) {
      if (this.music.currentIndex !== this.music.playlist.length - 1) {
        this.doChangeAudio(this.music.currentIndex + 1);
      } else {
        this.music.resetCover = !this.music.resetCover;
        this.pauseAudio(this.play);
      }
    }
  }

  private handleCanPlay() {
    if (this.music.waitingPlay) {
      this.music.waitingPlay = false;
      this.setAudioCurrentTime(0);
      this.playAudio(this.play);
    }
  }

  private handlePlaying() {
    this.music.isPlay = true;
  }

  private handlePause() {
    this.music.isPlay = false;
  }

  //playAudio 播放音频
  private playAudio(btn: any, isClick: boolean = false) {
    const lines = btn.children;
    if (this.player !== null && this.playlist !== null) {
      this.player.play();
      lines[1].style.cssText = "transform:rotate(0);top: 0;left: 1.25vh;";
      lines[2].style.cssText = "transform:rotate(0);top: 0;left: 1.25vh;";
      this.playlist.children[this.music.currentIndex].classList.add("playing");
      if (isClick) {
        clearInterval(this.music.volumeTimer);
        this.music.volumeTimer = setInterval(() => {
          if (this.player !== null) {
            if (this.music.volume < 0.9) {
              this.music.volume += 0.1;
              this.player.volume = this.music.volume;
            } else {
              this.player.volume = this.music.volume = 1;
              clearInterval(this.music.volumeTimer);
            }
          }
        }, 50);
      } else {
        this.player.volume = this.music.volume = 1;
      }
    }
  }

  //pauseAudio 暂停音频
  private pauseAudio(btn: any, isClick: boolean = false) {
    const lines = btn.children;
    if (this.player !== null && this.playlist) {
      lines[1].style.cssText =
        "transform:rotate(-60deg);top: -0.375vh;left: 0.75vh;";
      lines[2].style.cssText =
        "transform:rotate(60deg);top: 0.5vh;left: 0.75vh;";
      this.playlist.children[this.music.currentIndex].classList.remove(
        "playing"
      );
      if (isClick) {
        clearInterval(this.music.volumeTimer);
        this.music.volumeTimer = setInterval(() => {
          if (this.player !== null) {
            if (this.music.volume > 0.1) {
              this.music.volume -= 0.1;
              this.player.volume = this.music.volume;
            } else {
              this.music.volume = 0;
              this.player.volume = this.music.volume;
              this.player.pause();
              clearInterval(this.music.volumeTimer);
            }
          }
        }, 50);
      } else {
        this.player.pause();
      }
    }
  }

  //audioSwitch 音频状态切换
  private audioSwitch(ev: any) {
    if (this.player !== null) {
      const btn = ev.target;
      if (this.music.isPlay) {
        this.pauseAudio(btn, true);
      } else {
        this.playAudio(btn, true);
      }
    }
  }

  //handleAudioTimeUpdate 接受音频进度条改变
  private handleAudioTimeUpdate() {
    if (this.player !== null) {
      const duration = this.player.duration,
        currentTime = this.player.currentTime;
      const timeRanges = this.player.buffered;
      if (timeRanges.length !== 0) {
        const timeBuffered = timeRanges.end(timeRanges.length - 1);
        const bufferedPer = (timeBuffered / duration) * 100;
        this.music.buffered = bufferedPer;
        const currentPer = (currentTime / duration) * 100;
        this.music.currentPer = currentPer;
      }
    }
  }

  /**
   * nav
   */

  private navChange(index: number) {
    if (
      this.main !== null &&
      this.navIndex !== null &&
      index !== this.navIndex
    ) {
      this.navDotTransform = `translateY(${9 * (index - 1)}vw)`;
      this.navTitleTransform = `translateY(${-9 * index}vw)`;
      const navItems = this.$refs.navItems as Element;
      const items = navItems.children;
      if (this.navIndex < index) {
        (items[this.navIndex].children[0]
          .children[0] as HTMLElement).style.cssText =
          "margin-top: 100%; height: 0%; opacity: 0";
        (items[index].children[0].children[0] as HTMLElement).style.cssText =
          "margin-top: 0; height: 100%; opacity: 1";
      } else {
        (items[this.navIndex].children[0]
          .children[0] as HTMLElement).style.cssText =
          "margin-top: -100%; height: 0%; opacity: 0";
        (items[index].children[0].children[0] as HTMLElement).style.cssText =
          "margin-top:0; height: 100%; opacity: 1";
      }
      this.prevNavIndex = this.navIndex;
      this.navIndex = index;

      // if (this.navIndex === 2) {
      //   setTimeout(() => {
      //     this.momentData = this.momentDataStored;
      //   }, 600);
      // }

      const current = this.main.children[this.navIndex],
        prev = this.main.children[this.prevNavIndex];
      current.classList.remove("main-out");
      current.classList.add("main-in");
      prev.classList.remove("main-in");
      prev.classList.add("main-out");
    }
  }

  /**
   * theme
   */

  private initTheme() {
    this.theme = this.getTheme();
    this.changeTheme(this.theme);
  }

  private getTheme(): boolean {
    return (localStorage.getItem("theme") || "night") === "night";
  }

  /**
   * picture
   */
  private pictureTabChange(value: string) {
    this.pictureTab = value;
  }

  private initLove() {
    const love = localStorage.getItem("loved");
    if (love === "true") {
      this.iLoveThis();
    }
  }

  private iLoveThis() {
    if (!this.isLoved) {
      this.isLoved = true;
      if (this.homeData.love && this.homeData.love.number)
        this.homeData.love!.number! =
          this.$utils.toNumber(this.homeData.love!.number!) + 1;
      localStorage.setItem("loved", "true");
    }
  }

  private goTo(href: string) {
    this.messageConfig.title = this.$lang.t("interface.message.goto") + href;
    this.messageConfig.onOk = () => {
      window.open(href);
    };
    this.isMessageShow = true;
  }

  private changeTheme(value: boolean) {
    if (value) {
      localStorage.setItem("theme", "night");
      document.body.style.setProperty(
        "--theme-background-color",
        "rgba(37,43,73,1)"
      );
      document.body.style.setProperty(
        "--theme-background-color-light",
        "rgba(42,60,96,1)"
      );
      document.body.style.setProperty(
        "--font-color-lightwhite",
        "rgba(255,255,255,0.66)"
      );
      document.body.style.setProperty("--font-color-white", "#fff");
      document.body.style.setProperty("--font-color-black", "#2c3e50");
    } else {
      localStorage.setItem("theme", "light");
      document.body.style.setProperty("--theme-background-color", "#fff");
      document.body.style.setProperty(
        "--theme-background-color-light",
        "#edeeee"
      );
      document.body.style.setProperty(
        "--font-color-lightwhite",
        "rgba(0,0,0,0.66)"
      );
      document.body.style.setProperty("--font-color-white", "#2c3e50");
      document.body.style.setProperty("--font-color-black", "#fff");
    }
  }
}
